import { ReactNode, createContext } from 'react';

import { PlaygroundStoreType } from './hooks/usePlaygroundStore';

// Context for determining which store to use
export const PlaygroundStoreContext =
  createContext<PlaygroundStoreType>('standard');

// Provider component
interface EvaluatorStoreProviderProps {
  children: ReactNode;
  storeType: PlaygroundStoreType;
}

export const EvaluatorStoreProvider = ({
  children,
  storeType,
}: EvaluatorStoreProviderProps) => {
  return (
    <PlaygroundStoreContext.Provider value={storeType}>
      {children}
    </PlaygroundStoreContext.Provider>
  );
};
